export default __webpack_public_path__ + "static/media/team-1.6ebf3a05.jpg";